import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSection } from "../../services/section";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateSection = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateSection,
        onMutate: () => {
            indicators.setIsProcessRunning(true);
            indicators.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if(status === 200) {
                queryClient.invalidateQueries({queryKey: ['questionnaire_content']});       
                indicators.setIsProcessRunning(false);
                toast.success("Section updated successfully"); 
            }
        },

        onError: (error: any) => {
            indicators.setIsServiceError(error?.response?.data?.message);
            indicators.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);    
        }
    });
}

export default useUpdateSection;